import { request } from "./request.js";

export async function save(data) {
    return await request("/case/save", data, "POST");
}

export async function get(key) {
    return await request("/case", { key: key }, "POST");
}

export async function checkupSave(data) {
    return await request("/checkup/case", data, "POST");
}
